import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';

import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { pxToRem } from '@/theme/typography';
import shallow from 'zustand/shallow';
import { useDialog } from '@/logic/state';
import { CloseButton } from '../shared/close-button';

export const CardNotSameVerifiedConfirmDialog: FC = () => {
  const theme = useTheme();

  const dialog = useDialog(s => s.dialog, shallow);

  const { handleOkayClick, handleContinueClick } =
    dialog?.cardNotSameVerifiedConfirmDialogPayload;

  return (
    <>
      <DialogTitle>
        <CloseButton handleClick={handleOkayClick} />
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            alignItems: 'center',
            margin: 'auto',
            textAlign: 'center',
          }}
        >
          <Typography
            sx={{
              color: theme.palette.grey[70],
              fontSize: pxToRem(18),
              fontWeight: 400,
              lineHeight: '27px',
              textAlign: 'center',
            }}
          >
            <FormattedMessage id='offer.card_not_same_verified' />
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions
        disableSpacing
        sx={{
          flexDirection: 'column',
        }}
      >
        <Button
          id='card-not-same-verified-info-dialog-okay'
          variant='contained'
          fullWidth
          onClick={handleOkayClick}
          sx={{
            marginBottom: '8px',
            height: {
              mobile: '56px',
              tablet: pxToRem(56),
            },
          }}
        >
          <FormattedMessage id='global.okay' />
        </Button>
        <Button
          id='card-not-same-verified-info-dialog-continue'
          variant='outlined'
          fullWidth
          onClick={handleContinueClick}
          sx={{
            height: {
              mobile: '56px',
              tablet: pxToRem(56),
            },
          }}
        >
          <FormattedMessage id='offer.continue_without_offer' />
        </Button>
      </DialogActions>
    </>
  );
};
